export {};

const form = document.querySelector<HTMLFormElement>('[data-help-search-form]');
const field = document.querySelector<HTMLInputElement>('[data-help-search]');
const clear = document.querySelector<HTMLButtonElement>('[data-help-clear]');
const status = document.querySelector<HTMLElement>('[data-help-results]');
const empty = document.querySelector<HTMLElement>('[data-help-empty]');
const topics = [...document.querySelectorAll<HTMLElement>('[data-help-topic]')];
const normalize = (text: string) => text.normalize('NFKC').toLocaleLowerCase().replaceAll('ё', 'е');
if (form && field && clear && status && empty) {
  const update = () => {
    const query = field.value.trim();
    const terms = normalize(query).split(/\s+/).filter(Boolean);
    let count = 0;
    for (const topic of topics) {
      topic.hidden = !terms.every((term) => normalize(topic.dataset.search ?? '').includes(term));
      if (!topic.hidden) count++;
    }
    status.textContent = (status.dataset.template ?? '{n}').replace('{n}', String(count));
    status.hidden = query.length === 0;
    empty.hidden = count !== 0;
    clear.hidden = query.length === 0;
    const url = new URL(location.href);
    if (query) url.searchParams.set('q', query);
    else url.searchParams.delete('q');
    history.replaceState(null, '', url);
  };
  field.value = new URL(location.href).searchParams.get('q') ?? '';
  form.hidden = false;
  field.addEventListener('input', update);
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    update();
  });
  clear.addEventListener('click', () => {
    field.value = '';
    update();
    field.focus();
  });
  update();
}
